


















import {
  defineComponent,
  useContext,
  useRouter,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import SfButton from '~/components/StorefrontUi/SfButton/SfButton.vue';
import { IconSingleArrowLeft } from './General/icons';

export default defineComponent({
  name: 'BackButton',
  components: {
    IconSingleArrowLeft,
    SfButton,
  },
  props: {
    label: {
      type: String,
      default: 'Back',
    },
  },
  setup(props) {
    const router = useRouter();
    const pushToBack = () => router.back();
    const { i18n } = useContext();

    const translatedLabel = i18n.t(props.label);

    return {
      pushToBack,
      addBasePath,
      translatedLabel,
    };
  },
});
